import React from "react";
import { TabelAkun } from "../../components/molecules";

const ListAkun = () => {
  return (
    <div className="w-full bg-custom-putih flex flex-col  h-screen mt-14 ml-80 ">
      <TabelAkun />
    </div>
  );
};

export default ListAkun;
